import React, { useEffect, useState, useRef } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../url';
import './Banners.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { useNavigate } from 'react-router-dom';
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Banners() {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const swiperRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        cargarBanners();
    }, []);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current?.update();
        }
    }, [banners]);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setBanners(data.banner || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar banners:', error);
            });
    };

    const handleCtaClick = (idCategoria) => {
        // Navega al home con ?cat=<id> — Products.jsx lo lee y hace scroll
        navigate(`/?cat=${idCategoria}`);
    };

    return (
        <div className='BannerContain'>

            {loading ? (
                <div className='loadingBanner'>

                </div>

            ) : (
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    loop={true}
                    slidesPerView={'auto'}
                    coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                    navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                    autoplay={{ delay: 3000 }}
                    pagination={{ clickable: true }}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    id='swiper_container'
                >
                    {banners.map((banner, index) => {
                        const hasCta = banner.idCategoria && banner.textoBoton && banner.textoBoton.trim() !== '';
                        return (
                            <SwiperSlide id='SwiperSlide-scroll' key={banner.idBanner || index}>
                                <div className='bannerSlideWrap'>
                                    <img src={banner.imagen} alt={`banner-${index}`} />
                                    {hasCta && (
                                        <button
                                            type='button'
                                            className='bannerCtaBtn'
                                            onClick={() => handleCtaClick(banner.idCategoria)}
                                        >
                                            {banner.textoBoton}
                                        </button>
                                    )}
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )}


        </div>
    );
}
